import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DESIGN_DEPARTMENT, EyebrowText, SectionHeadline } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { JobOpeningJobsWithTier } from "@faire/retailer-visitor-shared/views/careers/__internal__/JobOpenings/JobOpeningJobsWithTier";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column, Flex, HorizontalLine } from "@faire/web--source/slate/Layout";
import { GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
var JobOpeningsDivider = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "4x",
                    tabletAndAbove: "5x"
                }
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "4x",
                    tabletAndAbove: "5x"
                }
            })
        ]
    });
};
var JobOpeningsDepartment = function(param) {
    var department = param.department, isFirst = param.isFirst;
    var viewport = useViewport();
    var spacing = useResponsiveValue({
        mobileAndAbove: /*#__PURE__*/ _jsx(Spacer, {
            height: "3x"
        }),
        tabletAndAbove: /*#__PURE__*/ _jsx(Spacer, {
            height: "5x"
        }),
        desktopAndAbove: /*#__PURE__*/ _jsx(GrowingSpacer, {})
    });
    var getOpenRoles = function() {
        var childDepartments = department.childDepartments;
        if (childDepartments.length > 0) {
            return childDepartments.map(function(department) {
                return department.jobs.length;
            }).reduce(function(accumulatedQuantity, currentSubDepartmentJobQuantity) {
                return accumulatedQuantity + currentSubDepartmentJobQuantity;
            });
        }
        return department.jobs.length;
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isFirst ? null : /*#__PURE__*/ _jsx(JobOpeningsDivider, {}),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: department.title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: viewport.isMobile ? "1x" : "3x"
            }),
            /*#__PURE__*/ _jsxs(ResponsiveContainer, {
                children: [
                    department.name === DESIGN_DEPARTMENT ? /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                linkTo: "https://www.design.faire.com/",
                                target: "_blank",
                                variant: "tertiary",
                                children: [
                                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "dqiHnk",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Discover Design at Faire"
                                            }
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: "1x"
                                    }),
                                    /*#__PURE__*/ _jsx(Arrow, {
                                        direction: "right"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    spacing,
                    /*#__PURE__*/ _jsxs(List, {
                        children: [
                            /*#__PURE__*/ _jsx(EyebrowText, {
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "dF3uJ9",
                                    defaultMessage: [
                                        {
                                            type: 6,
                                            value: "openRolesNumber",
                                            options: {
                                                one: {
                                                    value: [
                                                        {
                                                            type: 7
                                                        },
                                                        {
                                                            type: 0,
                                                            value: " open role"
                                                        }
                                                    ]
                                                },
                                                other: {
                                                    value: [
                                                        {
                                                            type: 7
                                                        },
                                                        {
                                                            type: 0,
                                                            value: " open roles"
                                                        }
                                                    ]
                                                }
                                            },
                                            offset: 0,
                                            pluralType: "cardinal"
                                        }
                                    ],
                                    values: {
                                        openRolesNumber: getOpenRoles()
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "2x"
                            }),
                            /*#__PURE__*/ _jsx(JobOpeningJobsWithTier, {
                                department: department
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export var JobOpeningsList = function(param) {
    var departments = param.departments;
    if (departments.length === 0) {
        return /*#__PURE__*/ _jsxs(Column, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                }),
                /*#__PURE__*/ _jsx(SectionHeadline, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "/SrUoU",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "No current openings"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Column, {
        children: departments.map(function(department, i) {
            return /*#__PURE__*/ _jsx(JobOpeningsDepartment, {
                department: department,
                isFirst: i === 0
            }, department.name);
        })
    });
};
var ResponsiveContainer = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        desktopAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-e4ca762b-0"
})([
    ""
]);
var List = styled(Column).withConfig({
    componentId: "sc-e4ca762b-1"
})([
    "width:100%;max-width:540px;",
    "{align-self:center;}"
], responsiveMediaQueries.tablet);
